import { render } from "./AttachmentItem.vue?vue&type=template&id=41eaf8b7"
import script from "./AttachmentItem.vue?vue&type=script&lang=js"
export * from "./AttachmentItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__